// @ts-strict-ignore
import {Injectable} from "@angular/core";
import {NotificationService, SimConfigurationService, SimStreamService, SimSystemExtendedService, SimUtilityService} from "@services";
import {TranslateService} from "@ngx-translate/core";
import {Translations} from "@translations";
import {Media} from "@models";

/**
 * Provides extended utility methods, which rely on other services
 * This can not be directly injected into services that are a dependency of API services
 */
@Injectable({
	providedIn: "root",
})
export class SimUtilityExtendedService extends SimUtilityService {
	//Rolling index for video domains
	private static videoDomainIndex = -1;

	public constructor(
		private _simStreamService: SimStreamService,
		private _simNotificationService: NotificationService,
		private _translate: TranslateService,
		private _simSystemService: SimSystemExtendedService,
	) {
		super();
	}

	public copyToClipBoard(textToCopy: string): void {
		if (!navigator.clipboard) {
			this.fallbackCopyTextToClipboard(textToCopy);
			return;
		}
		navigator.clipboard.writeText(textToCopy).then(
			() => {
				console.log("Async: Copying to clipboard was successful!");
				this._simNotificationService.notifySuccess(
					this._translate.instant(this._translate.instant(Translations.SHARED_SUCCESSFUL_COPY_VALUE)),
				);
			},
			(err) => {
				console.error("Async: Could not copy text: ", err);
			},
		);
	}

	private fallbackCopyTextToClipboard(text) {
		let textArea = document.createElement("textarea");
		textArea.value = text;

		// Avoid scrolling to bottom
		textArea.style.top = "0";
		textArea.style.left = "0";
		textArea.style.position = "fixed";

		document.body.appendChild(textArea);
		textArea.focus();
		textArea.select();

		try {
			let successful = document.execCommand("copy");
			let msg = successful ? "successful" : "unsuccessful";
			console.log("Fallback: Copying text command was " + msg);
			this._simNotificationService.notifySuccess(
				this._translate.instant(this._translate.instant(Translations.SHARED_SUCCESSFUL_COPY_VALUE)),
			);
		} catch (err) {
			console.error("Fallback: Oops, unable to copy", err);
		}

		document.body.removeChild(textArea);
	}

	public getMediaPath(media: Media, width?: number, height?: number): string {
		if (media) {
			return this._simStreamService.getMedia_Url(media.id, null, height, width);
		} else {
			return "";
		}
	}

	public getMediaPathById(mediaId: string, width?: number, height?: number): string {
		return this._simStreamService.getMedia_Url(mediaId, null, height, width);
	}

	public getScenarioRecordingAudioUrl(scenarioRecordingId: string, scenarioRecordingSceneIndex: number): string {
		return this._simStreamService.getAudio_Url(scenarioRecordingId, scenarioRecordingSceneIndex);
	}

	public getScenarioRecordingVideoUrl(scenarioRecordingId: string, scenarioRecordingSceneIndex: number, videoIndex: number): string {
		//SIMSOFT-6720
		let domain = "";

		let availableDomains = SimConfigurationService.settings.videoDomains;
		if (availableDomains?.length) {
			SimUtilityExtendedService.videoDomainIndex = (SimUtilityExtendedService.videoDomainIndex + 1) % availableDomains.length;
			domain = `${location.protocol}//${availableDomains[SimUtilityExtendedService.videoDomainIndex]}`;
		}

		let url = this._simStreamService.getVideo_Url(scenarioRecordingId, scenarioRecordingSceneIndex, videoIndex);

		if (url.startsWith("/")) url = url.slice(1);
		if (domain.endsWith("/")) domain = domain.slice(0, -1);

		return `${domain}/${url}`;
	}
}
